import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LuStickyFilter } from './sticky-filters.model';
import { LuStickyFiltersService } from './sticky-filters.service';
import { Resolve } from 'src/app/core/interfaces/resolver.interface';
@Injectable()
export class LuStickyFiltersResolverService implements Resolve<LuStickyFilter> {
	constructor(private stickyFilterService: LuStickyFiltersService) {}
	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<LuStickyFilter> | Promise<LuStickyFilter> | LuStickyFilter {
		this.stickyFilterService.setStickyFilterOfCurrentRoute(state.url);
		return this.stickyFilterService.stickyFilterOfCurrentRoute;
	}
}

export const LuStickyFiltersResolverFn: ResolveFn<LuStickyFilter> = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => inject(LuStickyFiltersResolverService).resolve(route, state);
